import {
  HStack, VStack, Text, Badge, Box,
} from "@chakra-ui/react";

interface EventItemProps {
  title: string;
  time: string;
  date: string;
  type: "meeting" | "training" | "milestone";
  location?: string;
}

export default function EventItem({
  title, time, date, type, location,
}: EventItemProps) {
  const getEventTypeColor = (eventType: string) => {
    switch (eventType) {
      case "training": return { bg: "peopleTeamBlue.light", color: "peopleTeamBlue.dark" };
      case "meeting": return { bg: "cdsIndigo.50", color: "cdsIndigo.500" };
      case "milestone": return { bg: "cdsIndigo.50", color: "cdsIndigo.700" };
      default: return { bg: "gray.100", color: "gray.700" };
    }
  };

  const typeStyles = getEventTypeColor(type);

  return (
    <HStack
      p={3}
      bg="gray.50"
      borderRadius="md"
      justify="space-between"
      _hover={{ bg: "gray.100" }}
    >
      <HStack spacing={3} flex={1}>
        <Box
          w="4px"
          h="40px"
          bg={typeStyles.color}
          borderRadius="full"
        />
        <VStack align="start" spacing={1} flex={1}>
          <HStack>
            <Text fontSize="sm" fontWeight="medium" color="content.primary">
              {title}
            </Text>
            <Badge
              bg={typeStyles.bg}
              color={typeStyles.color}
              fontSize="xs"
              px={2}
              py={0.5}
              borderRadius="sm"
            >
              {type}
            </Badge>
          </HStack>
          {location && (
            <Text fontSize="xs" color="content.tertiary">
              {location}
            </Text>
          )}
        </VStack>
      </HStack>
      <VStack align="end" spacing={0}>
        <Text fontSize="sm" fontWeight="semibold" color="brand.500">
          {time}
        </Text>
        <Text fontSize="xs" color="content.tertiary">
          {date}
        </Text>
      </VStack>
    </HStack>
  );
}
